import {
    type EditFormResponseType,
    type EditFormRequestType
} from "./type";
import {
    request
} from "../request";

const EditForm = async (params: EditFormRequestType): Promise<EditFormResponseType> => {
    return await request<EditFormResponseType>("/events/editForm", {
        body: JSON.stringify(params),
        method: "PUT"
    });
};

export default EditForm;
